import React from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"
import { OVERVIEW_PAGE_CONTENT } from "../../Dashboard/constants"
import { liveLifeDashboardPath } from "../../Dashboard/LiveLife/constants"
import { getAssetPath } from "../../../utils/assets"

const StyledNav = styled.nav`
  img:first-child {
    width: 64px;
    margin-right: 1em;
  }
  img:last-child {
    display: none;
    @media (min-width: 768px) {
      display: inline-block;
    }
  }
`

function LiveLifeHeader({
 onSaveHandler, currentSection, lastPage, calculatorVersion
}) {
  // LiveLife is a multi-page flow; the top bar should reflect page progress,
  // so the final page ("last question") shows 100% immediately.
  const completionPercent = lastPage !== undefined && lastPage !== null && Number(lastPage) > 0
    ? Math.min(100, Math.max(0, (Number(currentSection) / Number(lastPage)) * 100))
    : 0
  const isV2 = String(calculatorVersion) === "2"
  const overviewContent = isV2 ? OVERVIEW_PAGE_CONTENT.live_life_v2 : OVERVIEW_PAGE_CONTENT.live_life
  const surveyName = isV2 ? "PQ Index" : "LiveLife Score"

  return (
    <div className="fixed-top">
      <StyledNav className="navbar navbar-light bg-white">
        <div>
          <Link to="/overview">
            <img src={getAssetPath("icn-back")} style={{ width: "30px" }} />
            <img style={{ width: "0px" }} />
          </Link>
          <Link to={liveLifeDashboardPath(calculatorVersion)}>
            <img src={getAssetPath(overviewContent.logoAssetName)} width={64} height={64} />
          </Link>
        </div>
        {onSaveHandler && <button className="btn btn-outline-main btn-sm" name="saveDraft" type="button" onClick={onSaveHandler}>Save Draft</button>}
      </StyledNav>
      <div className="progress survey-progress">
        <div
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={Math.round(completionPercent)}
          aria-label={`${surveyName} survey completion`}
          style={{ width: `${completionPercent}%` }}
          className="progress-bar"
          role="progressbar" />
      </div>
    </div>
  )
}

export default LiveLifeHeader